import isEmpty from 'ramda/src/isEmpty';
import { isDefined } from '~/utilities/array';

export default function purgeEmpty(val: any): any {
  if (val instanceof Array) {
    const result = val.map(value => purgeEmpty(value)).filter(isDefined);

    return isEmpty(result) ? undefined : result;
  }

  if (typeof val === 'object' && !isEmpty(val)) {
    const outerResult = Object.entries(val).reduce((acc, [key, value]) => {
      if (isEmpty(value)) {
        return acc;
      }

      const innerResult = purgeEmpty(value);

      if (!isEmpty(innerResult)) {
        acc[key] = innerResult;
      }

      return acc;
    }, {});

    return isEmpty(outerResult) ? undefined : outerResult;
  }

  return val;
}
